import { Navigate } from 'react-router-dom';
import { useAuth } from '../lib/auth-context';

/**
 * Porta de entrada da raiz do app.
 *
 * CORRECAO 2026-08-11: visitante sem sessao ia para `/signup`. Isso e errado em
 * dois cenarios reais: (a) quem ja tem conta e so voltou ao site cai num
 * formulario de cadastro em vez do login; (b) em ambientes onde o cadastro
 * publico esta fechado (stage, desde 2026-08-11), a rota vira um beco sem
 * saida — o usuario preenche o formulario e leva 403. O destino padrao de quem
 * nao tem sessao e o LOGIN; criar conta continua a um clique de la.
 */
export function RootIndex(): JSX.Element {
  const { isAuthenticated, onboardingCompleted } = useAuth();
  if (!isAuthenticated) return <Navigate to="/login" replace />;
  // D-051: roteamento inteligente pos-autenticacao.
  // onboardingCompleted=false → /onboarding; null (campo ausente) ou true → /mirror.
  if (onboardingCompleted === false) return <Navigate to="/onboarding" replace />;
  return <Navigate to="/mirror" replace />;
}
